import { MatMenuModule } from '@angular/material/menu';
import { NvButtonModule } from '../../../../nvps-libraries/design/nv-button/nv-button.module';
import { FormattedForTileType } from './pipes/tile-type/tile-type.pipe';
import { TilesComponent } from './tiles.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [TilesComponent, FormattedForTileType],
  imports: [CommonModule, MatCardModule, NvButtonModule, MatMenuModule],
  exports: [TilesComponent],
  providers: [FormattedForTileType],
})
export class TilesModule {}
